module.exports = __webpack_public_path__ + "static/img/tepat-waktu.e260b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/tepat-waktu.png
// module id = yeZC
// module chunks = 1